import zod from 'zod';
import { MANDATORY_FIELD } from '../../../config/zodConfig';
import { IntegrationFormSchema } from '../schemas';

export const SponteIntegrationFormSchema = zod
  .object({
    codigoCliente: zod.coerce.number({ required_error: MANDATORY_FIELD }),
    token: zod
      .string({ required_error: MANDATORY_FIELD })
      .min(1, MANDATORY_FIELD),
  })
  .merge(IntegrationFormSchema);
